import React, { useState, useEffect } from 'react';
import TimeUnit from './TimeUnit';

const CountdownCard = () => {
  const targetDateString = '2026-04-09T11:45:00-06:00';

  const calculateTimeLeft = () => {
    const targetDate = new Date(targetDateString);
    const now = new Date();
    const difference = targetDate.getTime() - now.getTime();

    if (difference > 0) {
      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className="pt-6 pb-5 px-5 sm:px-7 w-fit mx-4 shadow-2xl"
      style={{ background: 'linear-gradient(to bottom,#0200ba 0%,#010040 100%)' }}
    >
      <div className="flex flex-col items-center">
        <h1
          style={{ fontFamily: "'Oswald',sans-serif", fontWeight: 700 }}
          className="text-[28px] sm:text-[38px] text-white mb-5 text-center leading-none tracking-wide uppercase"
        >
          Jessica &amp; Matt
        </h1>

        <div className="flex flex-row items-center justify-center mb-5">
          <TimeUnit value={timeLeft.days} label="días" />
          <TimeUnit value={timeLeft.hours} label="horas" />
          <TimeUnit value={timeLeft.minutes} label="minutos" />
          <TimeUnit value={timeLeft.seconds} label="segundos" isLast={true} />
        </div>

        <div className="w-full pt-4 border-t border-white/20 text-center">
          <p
            style={{ fontFamily: "'Oswald',sans-serif", fontWeight: 400 }}
            className="text-white text-[14px] sm:text-[16px] tracking-wider uppercase"
          >
            9 de abril de 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default CountdownCard;